import InlineLoading from '../InlineLoading/InlineLoading';

import * as React from 'react';

interface IOverlayLoadingProps {
    size?: number;
    text?: string;
    onWhite?: boolean;
}

class OverlayLoading extends React.Component<IOverlayLoadingProps, unknown> {
    render() {
        const {
            size,
            text,
            onWhite
        } = this.props;

        let textSize = size ? size : 40;


        const loading = <div key={"loading"} className="loading-component">
            <InlineLoading size={textSize} text={text} absoluteCenter={true} />
        </div >

        if (onWhite) {
            return <div>
                {loading}
            </div>
        }


        return (
            loading
        );
    }
}
export default OverlayLoading;